<script lang="ts">
  import type { Filter } from "@shared/types/Filters";

  export let updateFilter;
  export let filter;
  export let filters: Filter[];
  export let checked;
  export let filterExpanded: boolean = false;

  const data = filters && filters.length > 0 ? filters[0].data : {};

  const min = data.min;
  const max = data.max;
  const banned_keys = filter.range.is_decimal ? ["-", "e", "+"] : ["-", "e", "+", "."];

  let from = data.from;
  let to = data.to;

  const open = from || to || checked || filterExpanded;

  const isEnable = () => {
    let _to = to ? to : 10000;
    let _from = from ? from : 0;
    return (
      ((from || to) && _to >= _from && (data.from != from || to != data.to)) ||
      (from == 0 && to == 0)
    );
  };

  let disabled = !isEnable();

  const processValue = e => {
    if (e.target.value.length === 0) {
      return null;
    }
    let raw = e.target.value;
    let maxLength = e.target.maxLength;
    if (maxLength > 0 && raw.length > maxLength) {
      raw = raw.substr(0, maxLength);
    }
    let v = Math.abs(parseFloat(raw));
    if (filter.range.is_decimal) {
      let money = Math.trunc(v * 100) / 100;
      v = money;
    } else {
      v = Math.trunc(v);
    }
    disabled = !isEnable();
    return v;
  };

  const onToChange = e => {
    to = processValue(e);
  };

  const onFromChange = e => {
    from = processValue(e);
  };

  const onKeypress = e => {
    if (banned_keys.includes(e.key)) {
      e.preventDefault();
    } else {
      if (e.key === "Enter" && !disabled) {
        onSubmit();
        e.preventDefault();
      }
    }
  };

  const onSubmit = () => {
    if (from || to || (from == 0 && to == 0)) {
      updateFilter(filter, { id: from === to ? from : (from ? from : "") + "-" + (to ? to : "") });
    }
  };
</script>

<div class="fizz-card side-filter fizz-inset-vertical-8" id={filter.key + "-filter"}>
  <details class="fizz-accordion" {open}>
    <summary class="side-filter-header">
      <span class="fizz-heading-6">{filter.name}</span>
    </summary>
    <div class="fizz-inset-horizontal-16 fizz-flow-8">
      <dl class="side-filter__list">
        {#if filter.description}
          <dt class="side-filter__item fizz-stack-8"><p><small>{filter.description}</small></p></dt>
        {/if}
        <div class="fizz-flex-row-8 margin-bottom--smaller">
          <div class="grid-col w-year">
            <label class="fizz-label display-none" for={filter.key + "-from"}>From</label>
            <input
              type="number"
              bind:value={from}
              maxlength={filter.range.max_length}
              size="4"
              step="any"
              name={filter.key + "-from"}
              id={filter.key + "-from"}
              placeholder={filter.range.from_placeholder}
              class="fizz-input-text"
              on:input={onFromChange}
              on:keypress={onKeypress}
            />
          </div>
          <p>to</p>
          <div class="grid-col w-year">
            <label class="fizz-label display-none" for={filter.key + "-to"}>To</label>
            <input
              type="number"
              bind:value={to}
              maxlength={filter.range.max_length}
              size="4"
              step="any"
              name={filter.key + "-to"}
              id={filter.key + "-to"}
              placeholder={filter.range.to_placeholder}
              class="fizz-input-text"
              on:input={onToChange}
              on:keypress={onKeypress}
            />
          </div>
          <button {disabled} on:click={onSubmit} class="fizz-button grid-col c3-12">Go</button>
        </div>
      </dl>
    </div>
  </details>
</div>
